<app-modal class="equipment-modal">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.details.detailsPage.modals.equipmentEditModal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-equipment-form
            *ngIf="selectedEquipment"
            [showValidations]="showValidations"
            [selectedEquipment]="selectedEquipment"
            [availableEquipment]="availableEquipment">
        </app-equipment-form>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    (click)="clickEquipmentUpdate()">
            {{ 'generic.buttons.update'| translate }}
        </app-button>
    </div>
</app-modal>
